import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import { auth } from "../../firebase";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import EspecialCard from "../../components/EspecialCard";
import ModalProducto from "../../components/ModalProducto";
import FloatingCart from "../../components/FloatingCart";
import PopupEspecial from "../../components/PopupEspecial";
import useTiendaData from "../../hooks/useTiendaData";
import useConfiguracionNegocio from "../../hooks/useConfiguracionNegocio";
import DecoracionesTienda from "../../components/DecoracionesTienda";
import BannerInstalarApp from "../../components/cliente/BannerInstalarApp";
import CategoriasTienda from "../../components/cliente/CategoriasTienda";
import SeccionProductosHorizontal from "../../components/cliente/SeccionProductosHorizontal";
import AvisoTiendaCerrada from "../../components/cliente/AvisoTiendaCerrada";
import useFavoritosCliente from "../../hooks/useFavoritosCliente";
import useUltimoPedidoCliente from "../../hooks/useUltimoPedidoCliente";
import useCategoriasOrdenadas from "../../hooks/useCategoriasOrdenadas";
import AcordeonCategoria from "../../components/cliente/AcordeonCategoria";
import BarraNavegacionInferior from "../../components/cliente/BarraNavegacionInferior";

function Tienda() {
  const navigate = useNavigate();
  const POPUP_VISTO_KEY = "mitico_popup_visto";

  const [turnoActual, setTurnoActual] = useState("");

  const {
    productos,
    catalogoCompleto,
    banners,
    especiales,
    promocionesActivas,
    cargarTiendaMítica,
  } = useTiendaData(turnoActual);

  const { configuracionNegocio, cargandoConfiguracion, estadoTienda } =
    useConfiguracionNegocio();

  const logoNegocio = configuracionNegocio.logoUrl || "/logo-mitico.png";
  const nombreNegocio = configuracionNegocio.nombreNegocio || "Mítico Amorcito";
  const logoAnchoPx = Number(configuracionNegocio.logoAnchoPx || 120);
  const logoAltoMaxPx = Number(configuracionNegocio.logoAltoMaxPx || 42);
  const [menuAbierto, setMenuAbierto] = useState(false);
  const [carrito, setCarrito] = useState([]);
  const [categoriasAbiertas, setCategoriasAbiertas] = useState({});
  const [gruposAbiertos, setGruposAbiertos] = useState({
    ALIMENTOS: true,
    BEBIDAS: true,
  });
  const toggleCategoria = useCallback((categoria) => {
    setCategoriasAbiertas((prev) => {
      const yaEstaAbierta = Boolean(prev[categoria]);

      return yaEstaAbierta
        ? {}
        : {
            [categoria]: true,
          };
    });
  }, []);
  const [usuario, setUsuario] = useState(null);
  const [cargandoSesion, setCargandoSesion] = useState(true);
  const { favoritosIds, esFavorito, toggleFavorito } = useFavoritosCliente();
  const { 鼓timoPedidoIds, ultimoPedidoIds } = useUltimoPedidoCliente();
  const [mostrarPopup, setMostrarPopup] = useState(false);
  const [especialActual, setEspecialActual] = useState(null);
  const [popupIndex, setPopupIndex] = useState(0);
  const [bannerActivo, setBannerActivo] = useState(0);
  const [mostrarModalProducto, setMostrarModalProducto] = useState(false);
  const [productoSeleccionado, setProductoSeleccionado] = useState(null);
  const [modalInfoEspecial, setModalInfoEspecial] = useState(null);
  const [opcionesSeleccionadas, setOpcionesSeleccionadas] = useState({});
  const [extrasSeleccionados, setExtrasSeleccionados] = useState([]);
  const [comentarioProducto, setComentarioProducto] = useState("");
  const [extrasCortesiaSeleccionados, setExtrasCortesiaSeleccionados] =
    useState([]);
  const [comentarioCortesia, setComentarioCortesia] = useState("");
  const [busquedaTexto, setBusquedaTexto] = useState("");
  const [busquedaDebounce, setBusquedaDebounce] = useState("");
  const [mostrarResultadosBusqueda, setMostrarResultadosBusqueda] =
    useState(false);

  const seccionesRef = useRef({});
  const especialesScrollRef = useRef(null);
  const timerAdminLogoRef = useRef(null);
  const presionLargaAdminRef = useRef(false);

  const [categoriaAnimadaIndex, setCategoriaAnimadaIndex] = useState(0);
  const detectarAppInstalada = () => {
    return (
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true
    );
  };

  const [installPromptEvent, setInstallPromptEvent] = useState(null);
  const [mensajeInstalacion, setMensajeInstalacion] = useState("");
  const [appInstalada, setAppInstalada] = useState(detectarAppInstalada());
  const iniciarPresionLogoAdmin = () => {
    presionLargaAdminRef.current = false;

    if (timerAdminLogoRef.current) {
      clearTimeout(timerAdminLogoRef.current);
    }

    timerAdminLogoRef.current = setTimeout(() => {
      presionLargaAdminRef.current = true;

      const confirmar = window.confirm("¿Deseas acceder al administrador?");

      if (confirmar) {
        navigate("/admin");
      }
    }, 5000);
  };

  const cancelarPresionLogoAdmin = () => {
    if (timerAdminLogoRef.current) {
      clearTimeout(timerAdminLogoRef.current);
      timerAdminLogoRef.current = null;
    }
  };

  const handleClickLogoAdmin = () => {
    if (presionLargaAdminRef.current) {
      presionLargaAdminRef.current = false;
      return;
    }

    navigate("/");
  };

  const verificarTurnoPorHorario = () => {
    const ahora = new Date();
    const hora = ahora.getHours();

    if (hora >= 8 && hora < 13) {
      setTurnoActual("matutino");
    } else {
      setTurnoActual("vespertino");
    }
  };

  useEffect(() => {
    setAppInstalada(detectarAppInstalada());

    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setInstallPromptEvent(event);
    };

    const handleAppInstalled = () => {
      setInstallPromptEvent(null);
      setAppInstalada(true);
      setMensajeInstalacion("✅ App instalada correctamente.");
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    window.addEventListener("appinstalled", handleAppInstalled);

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt,
      );
      window.removeEventListener("appinstalled", handleAppInstalled);
    };
  }, []);

  useEffect(() => {
    const carritoGuardado = localStorage.getItem("carritoMitico");

    if (carritoGuardado) {
      try {
        setCarrito(JSON.parse(carritoGuardado));
      } catch (error) {
        console.error("Error al leer carrito:", error);
      }
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("carritoMitico", JSON.stringify(carrito));
  }, [carrito]);

  useEffect(() => {
    const desuscribir = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUsuario(user);
      } else {
        setUsuario(null);
      }

      setCargandoSesion(false);
    });

    const timerSeguridad = setTimeout(() => {
      setCargandoSesion(false);
    }, 2000);

    return () => {
      desuscribir();
      clearTimeout(timerSeguridad);
    };
  }, []);

  useEffect(() => {
    verificarTurnoPorHorario();
  }, []);

  useEffect(() => {
    if (turnoActual && !cargandoSesion) {
      cargarTiendaMítica();

      const intervalo = setInterval(verificarTurnoPorHorario, 60000);

      return () => clearInterval(intervalo);
    }
  }, [turnoActual, cargandoSesion, cargarTiendaMítica]);

  useEffect(() => {
    if (especiales.length === 0) {
      return;
    }

    setPopupIndex(0);
    setEspecialActual(especiales[0]);

    const popupYaVisto = sessionStorage.getItem(POPUP_VISTO_KEY);

    if (!popupYaVisto) {
      setMostrarPopup(true);
      sessionStorage.setItem(POPUP_VISTO_KEY, "true");
    }
  }, [especiales]);

  const promocionesVisuales = useMemo(() => {
    return promocionesActivas
      .filter((promo) => promo.activa !== false)
      .map((promo) => {
        if (promo.tipo === "envio_gratis") {
          const minimoEnvioGratis =
            promo.minimo || promo.montoMinimo || promo.minimoCompra || 0;

          return {
            id: `promo-${promo.id}`,
            promoId: promo.id,
            esPromoSistema: true,
            tipoPromo: promo.tipo,
            emoji: "🛵",
            titulo: "Envío gratis",
            subtitulo: `En pedidos a domicilio desde $${Number(
              minimoEnvioGratis,
            ).toFixed(0)} MXN.`,
            descripcion: `En pedidos a domicilio desde $${Number(
              minimoEnvioGratis,
            ).toFixed(0)} MXN.`,
            url: promo.url || logoNegocio,
          };
        }

        if (promo.tipo === "2x1") {
          const productoPromo = productos.find(
            (p) => p.id === promo.productoId,
          );

          if (!productoPromo) return null;

          return {
            id: `promo-${promo.id}`,
            promoId: promo.id,
            esPromoSistema: true,
            tipoPromo: promo.tipo,
            productoId: promo.productoId,
            emoji: "🔥",
            titulo: "Promoción 2x1",
            subtitulo: `Compra 2 ${productoPromo.nombre} y paga solo 1.`,
            descripcion: `Compra 2 ${productoPromo.nombre} y paga solo 1.`,
            url: promo.url || productoPromo.imagen || logoNegocio,
          };
        }

        if (promo.tipo === "regalo") {
          const productoDetonante = productos.find(
            (p) => p.id === promo.detonanteId,
          );

          if (!productoDetonante) return null;

          const productoRegalo =
            productos.find((p) => p.id === promo.regaloId) ||
            catalogoCompleto.find((p) => p.id === promo.regaloId);

          return {
            id: `promo-${promo.id}`,
            promoId: promo.id,
            esPromoSistema: true,
            tipoPromo: promo.tipo,
            detonanteId: promo.detonanteId,
            regaloId: promo.regaloId,
            emoji: "🎁",
            titulo: "Cortesía especial",
            subtitulo: productoRegalo
              ? `En la compra de ${productoDetonante.nombre}, recibe ${productoRegalo.nombre} de cortesía.`
              : `En la compra de ${productoDetonante.nombre}, recibe una cortesía.`,
            descripcion: productoRegalo
              ? `En la compra de ${productoDetonante.nombre}, recibe ${productoRegalo.nombre} de cortesía.`
              : `En la compra de ${productoDetonante.nombre}, recibe una cortesía.`,
            url:
              promo.url ||
              productoRegalo?.imagen ||
              productoDetonante.imagen ||
              logoNegocio,
          };
        }

        return null;
      })
      .filter(Boolean);
  }, [promocionesActivas, productos, catalogoCompleto, logoNegocio]);

  const bannersVisibles = useMemo(() => {
    return [...banners, ...promocionesVisuales];
  }, [banners, promocionesVisuales]);

  const especialesVisibles = useMemo(() => {
    const listaCombinada = [...promocionesVisuales, ...especiales];

    return listaCombinada.filter((esp) => {
      // 1. Si es promoción de sistema (2x1, regalo, etc.), verificar si su producto está activo en este turno
      if (esp.esPromoSistema) {
        if (esp.productoId) {
          return productos.some((p) => p.id === esp.productoId);
        }
        if (esp.detonanteId) {
          return productos.some((p) => p.id === esp.detonanteId);
        }
        return true;
      }

      // 2. Si se configuró manualmente un turno en el especial ("matutino", "vespertino" o "todos")
      if (esp.turno && esp.turno !== "auto" && esp.turno !== "todos") {
        return esp.turno === turnoActual;
      }

      // 3. Si tiene un producto asociado directamente (comportamiento automático inteligente)
      if (esp.productoId) {
        // Verifica si el platillo existe dentro de los productos disponibles en el turno actual
        const platilloEnTurno = productos.some((p) => p.id === esp.productoId);
        return platilloEnTurno;
      }

      // 4. Si es aviso general sin platillo ni turno específico, se muestra en ambos turnos
      return true;
    });
  }, [promocionesVisuales, especiales, productos, turnoActual]);

  useEffect(() => {
    if (!bannersVisibles || bannersVisibles.length <= 1) {
      return;
    }

    const intervaloBanner = setInterval(() => {
      setBannerActivo((prev) =>
        prev >= bannersVisibles.length - 1 ? 0 : prev + 1,
      );
    }, 5000);

    return () => clearInterval(intervaloBanner);
  }, [bannersVisibles]);

  useEffect(() => {
    if (!mostrarPopup || !especiales || especiales.length <= 1) {
      return;
    }

    const intervaloPopup = setInterval(() => {
      setPopupIndex((prev) => (prev >= especiales.length - 1 ? 0 : prev + 1));
    }, 5000);

    return () => clearInterval(intervaloPopup);
  }, [mostrarPopup, especiales]);

  useEffect(() => {
    const contenedor = especialesScrollRef.current;

    if (!contenedor || especialesVisibles.length <= 1) {
      return;
    }

    const intervalo = setInterval(() => {
      const maxScroll = contenedor.scrollWidth - contenedor.clientWidth;

      if (maxScroll <= 0) {
        return;
      }

      if (contenedor.scrollLeft >= maxScroll - 10) {
        contenedor.scrollTo({
          left: 0,
          behavior: "smooth",
        });
      } else {
        contenedor.scrollBy({
          left: 180,
          behavior: "smooth",
        });
      }
    }, 2800);

    return () => clearInterval(intervalo);
  }, [especialesVisibles]);

  useEffect(() => {
    if (especiales.length === 0) {
      setEspecialActual(null);
      return;
    }

    setEspecialActual(especiales[popupIndex] || null);
  }, [popupIndex, especiales]);

  const menuAgrupadoPorSeccion = useMemo(() => {
    return productos.reduce((acc, prod) => {
      const seccionMayus = prod.seccion
        ? prod.seccion.toUpperCase().trim()
        : "VARIOS";

      if (!acc[seccionMayus]) {
        acc[seccionMayus] = [];
      }

      acc[seccionMayus].push(prod);

      return acc;
    }, {});
  }, [productos]);

  const listaDeSecciones = useMemo(() => {
    return Object.keys(menuAgrupadoPorSeccion);
  }, [menuAgrupadoPorSeccion]);

  const { categoriasOrdenadas, categoriasConfiguradas } =
    useCategoriasOrdenadas({
      categoriasDetectadas: listaDeSecciones,
      turnoActivo: turnoActual,
    });

  const categoriasPorGrupo = useMemo(() => {
    const alimentos = [];
    const bebidas = [];

    categoriasOrdenadas.forEach((nombreCategoria) => {
      const categoriaConfig = categoriasConfiguradas.find(
        (categoria) =>
          categoria.nombre?.toUpperCase() === nombreCategoria.toUpperCase(),
      );

      const grupo = categoriaConfig?.grupo || "ALIMENTOS";

      if (grupo === "BEBIDAS") {
        bebidas.push(nombreCategoria);
      } else {
        alimentos.push(nombreCategoria);
      }
    });

    return {
      alimentos,
      bebidas,
    };
  }, [categoriasOrdenadas, categoriasConfiguradas]);

  useEffect(() => {
    if (!listaDeSecciones || listaDeSecciones.length <= 1) {
      return;
    }

    const intervalo = setInterval(() => {
      setCategoriaAnimadaIndex((prev) =>
        prev >= listaDeSecciones.length - 1 ? 0 : prev + 1,
      );
    }, 850);

    return () => clearInterval(intervalo);
  }, [listaDeSecciones]);

  useEffect(() => {
    if (!categoriasOrdenadas.length) return;

    setCategoriasAbiertas((prev) => {
      if (Object.keys(prev).length > 0) return prev;

      return {
        [categoriasOrdenadas[0]]: true,
      };
    });
  }, [categoriasOrdenadas]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setBusquedaDebounce(busquedaTexto);
    }, 250);

    return () => clearTimeout(timer);
  }, [busquedaTexto]);

  const normalizarBusqueda = useCallback((texto = "") => {
    return String(texto)
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim();
  }, []);

  const sinonimosBusqueda = {
    cafe: [
      "cafe",
      "americano",
      "espresso",
      "capuccino",
      "cappuccino",
      "latte",
      "moka",
      "mocha",
      "macchiato",
    ],
    jugo: ["jugo", "jugos"],
    te: ["te", "té", "infusion", "infusión"],
    waffle: ["waffle", "waffles"],
    huevo: ["huevo", "huevos", "omelette", "omelet"],
    sandwich: ["sandwich", "sándwich", "chapata", "bagel"],
    pan: ["pan", "pan dulce", "croissant", "cuernito", "postre"],
    licuado: ["licuado", "licuados", "smoothie", "smoothies"],
    alcohol: ["alcohol", "cerveza", "vino", "coctel", "cocktail", "trago"],
    desayuno: [
      "desayuno",
      "desayunos",
      "chilaquiles",
      "huevos",
      "molletes",
      "waffles",
      "toast",
    ],
  };

  const obtenerTerminosBusqueda = useCallback(
    (texto) => {
      const textoNormal = normalizarBusqueda(texto);

      if (!textoNormal) return [];

      const terminos = new Set([textoNormal]);

      Object.entries(sinonimosBusqueda).forEach(([clave, sinonimos]) => {
        if (clave.includes(textoNormal) || sinonimos.includes(textoNormal)) {
          sinonimos.forEach((sinonimo) => {
            terminos.add(normalizarBusqueda(sinonimo));
          });
        }
      });

      return Array.from(terminos);
    },
    [normalizarBusqueda],
  );

  const textoNorm = useMemo(() => {
    return normalizarBusqueda(busquedaDebounce);
  }, [busquedaDebounce, normalizarBusqueda]);

  const resultadosSecciones = useMemo(() => {
    if (!textoNorm) return [];

    return listaDeSecciones
      .filter((sec) => sec.toLowerCase().includes(textoNorm))
      .slice(0, 6);
  }, [textoNorm, listaDeSecciones]);

  const resultadosProductos = useMemo(() => {
    if (!textoNorm) return [];

    const terminos = obtenerTerminosBusqueda(textoNorm);

    return productos
      .filter((p) => {
        const nombre = normalizarBusqueda(p.nombre);
        const descripcion = normalizarBusqueda(p.descripcion);
        const categoria = normalizarBusqueda(p.seccion);

        return terminos.some(
          (termino) =>
            nombre.includes(termino) ||
            descripcion.includes(termino) ||
            categoria.includes(termino),
        );
      })
      .slice(0, 8);
  }, [textoNorm, productos, normalizarBusqueda, obtenerTerminosBusqueda]);

  const masVendidosRelleno = useMemo(() => {
    return productos.slice(0, 4);
  }, [productos]);

  const productosFavoritos = useMemo(() => {
    if (!favoritosIds.length) {
      return [];
    }

    const favoritosSet = new Set(favoritosIds);

    return catalogoCompleto.filter((producto) => favoritosSet.has(producto.id));
  }, [catalogoCompleto, favoritosIds]);

  const productosUltimoPedido = useMemo(() => {
    if (!ultimoPedidoIds.length) {
      return [];
    }

    const productosPorId = new Map(
      catalogoCompleto.map((producto) => [producto.id, producto]),
    );

    return ultimoPedidoIds
      .map((productoId) => productosPorId.get(productoId))
      .filter(Boolean);
  }, [catalogoCompleto, ultimoPedidoIds]);

  const irASeccion = useCallback((nombreSeccion) => {
    setMenuAbierto(false);

    setCategoriasAbiertas((prev) => ({
      ...prev,
      [nombreSeccion]: true,
    }));

    setTimeout(() => {
      const elemento = seccionesRef.current[nombreSeccion];

      if (elemento) {
        elemento.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }, 80);
  }, []);

  const handlePopupSiguiente = () => {
    if (!especiales || especiales.length === 0) return;

    setPopupIndex((prev) => (prev >= especiales.length - 1 ? 0 : prev + 1));
  };

  const handlePopupAnterior = () => {
    if (!especiales || especiales.length === 0) return;

    setPopupIndex((prev) => (prev <= 0 ? especiales.length - 1 : prev - 1));
  };

  const handleAbrirConfiguracionProducto = useCallback((producto) => {
    setProductoSeleccionado(producto);
    setOpcionesSeleccionadas({});
    setExtrasSeleccionados([]);
    setComentarioProducto("");
    setMostrarModalProducto(true);
  }, []);

  const handleClickEspecial = useCallback(
    (especial) => {
      if (!especial) return;

      setMostrarPopup(false);

      // 1. Si el Especial tiene un platillo asociado directamente
      if (especial.productoId) {
        const prodDirecto =
          productos.find((p) => p.id === especial.productoId) ||
          catalogoCompleto.find((p) => p.id === especial.productoId);

        if (prodDirecto) {
          const seccionDestino = prodDirecto.seccion?.toUpperCase();
          if (seccionDestino) {
            irASeccion(seccionDestino);
          }
          setTimeout(() => {
            handleAbrirConfiguracionProducto(prodDirecto);
          }, 300);
          return;
        }
      }

      // 2. Si el Especial está vinculado a una promoción activa
      let promoRelacionada = null;
      if (especial.promoId) {
        promoRelacionada = promocionesActivas.find(
          (promo) => promo.id === especial.promoId,
        );
      }

      if (promoRelacionada) {
        let productoObjetivo = null;

        if (promoRelacionada.tipo === "2x1" && promoRelacionada.productoId) {
          productoObjetivo =
            productos.find((p) => p.id === promoRelacionada.productoId) ||
            catalogoCompleto.find((p) => p.id === promoRelacionada.productoId);
        }

        if (
          promoRelacionada.tipo === "regalo" &&
          promoRelacionada.detonanteId
        ) {
          productoObjetivo =
            productos.find((p) => p.id === promoRelacionada.detonanteId) ||
            catalogoCompleto.find((p) => p.id === promoRelacionada.detonanteId);
        }

        if (promoRelacionada.tipo === "envio_gratis") {
          alert(
            `🛵 ${promoRelacionada.tipo.toUpperCase()}: ${especial.descripcion || "Consulta compras mínimas para envío gratis."}`,
          );
          return;
        }

        if (productoObjetivo) {
          const seccionDestino = productoObjetivo.seccion?.toUpperCase();
          if (seccionDestino) {
            irASeccion(seccionDestino);
          }
          setTimeout(() => {
            handleAbrirConfiguracionProducto(productoObjetivo);
          }, 300);
          return;
        }
      }

      // 3. Si no tiene platillo ni promo: abrir la ventana flotante con info
      setModalInfoEspecial(especial);
    },
    [
      promocionesActivas,
      productos,
      catalogoCompleto,
      irASeccion,
      handleAbrirConfiguracionProducto,
    ],
  );

  const handleCambiarOpcionSinCosto = (grupo, opcion) => {
    setOpcionesSeleccionadas((prev) => {
      const tipo = grupo.tipo || "unica";

      if (tipo === "multiple") {
        const actuales = Array.isArray(prev[grupo.nombre])
          ? prev[grupo.nombre]
          : [];

        const yaExiste = actuales.includes(opcion);

        return {
          ...prev,
          [grupo.nombre]: yaExiste
            ? actuales.filter((item) => item !== opcion)
            : [...actuales, opcion],
        };
      }

      return {
        ...prev,
        [grupo.nombre]: opcion,
      };
    });
  };

  const handleToggleExtra = (extra) => {
    const yaExiste = extrasSeleccionados.some((e) => e.nombre === extra.nombre);

    if (yaExiste) {
      setExtrasSeleccionados(
        extrasSeleccionados.filter((e) => e.nombre !== extra.nombre),
      );
    } else {
      setExtrasSeleccionados([...extrasSeleccionados, extra]);
    }
  };

  const handleToggleExtraCortesia = (extra) => {
    const yaExiste = extrasCortesiaSeleccionados.some(
      (e) => e.nombre === extra.nombre,
    );

    if (yaExiste) {
      setExtrasCortesiaSeleccionados(
        extrasCortesiaSeleccionados.filter((e) => e.nombre !== extra.nombre),
      );
    } else {
      setExtrasCortesiaSeleccionados([...extrasCortesiaSeleccionados, extra]);
    }
  };

  const handleConfirmarAgregarAlCarrito = () => {
    if (!productoSeleccionado) return;
    const opcionesProducto = productoSeleccionado.opcionesSinCosto || [];

    const opcionesRequeridasFaltantes = opcionesProducto.filter((grupo) => {
      const requerido = grupo.requerido || grupo.required;

      if (!requerido) return false;

      const valor = opcionesSeleccionadas[grupo.nombre];

      if (Array.isArray(valor)) return valor.length === 0;

      return !valor;
    });

    if (opcionesRequeridasFaltantes.length > 0) {
      alert(
        `Selecciona: ${opcionesRequeridasFaltantes
          .map((grupo) => grupo.nombre)
          .join(", ")}`,
      );
      return;
    }

    const opcionesSeleccionadasLista = opcionesProducto
      .map((grupo) => {
        const valor = opcionesSeleccionadas[grupo.nombre];

        if (!valor || (Array.isArray(valor) && valor.length === 0)) {
          return null;
        }

        return {
          nombre: grupo.nombre,
          tipo: grupo.tipo || "unica",
          seleccion: valor,
        };
      })
      .filter(Boolean);
    const timestamp = Date.now();
    const idCarritoPadre = `${productoSeleccionado.id}_${timestamp}`;

    const totalExtrasProducto = extrasSeleccionados.reduce(
      (sum, e) => sum + (e.precio || 0),
      0,
    );

    const totalExtrasCortesia = extrasCortesiaSeleccionados.reduce(
      (sum, e) => sum + (e.precio || 0),
      0,
    );

    const itemCarrito = {
      ...productoSeleccionado,
      cantidad: 1,
      idCarrito: idCarritoPadre,
      opcionesSeleccionadas: opcionesSeleccionadasLista,
      extras: extrasSeleccionados,
      comentario: comentarioProducto.trim(),
      precio: productoSeleccionado.precio + totalExtrasProducto,
    };

    let nuevosItems = [itemCarrito];

    const promoRegalo = promocionesActivas.find(
      (p) => p.tipo === "regalo" && p.detonanteId === productoSeleccionado.id,
    );

    if (promoRegalo) {
      const productoARegalar =
        productos.find((p) => p.id === promoRegalo.regaloId) ||
        catalogoCompleto.find((p) => p.id === promoRegalo.regaloId);

      if (productoARegalar) {
        nuevosItems.push({
          ...productoARegalar,
          cantidad: 1,
          idCarrito: `REGALO_${productoARegalar.id}_${timestamp}`,
          regaloDeIdCarrito: idCarritoPadre,
          promoId: promoRegalo.id,
          extras: extrasCortesiaSeleccionados,
          comentario: comentarioCortesia.trim(),
          nombre: `[CORTESÍA] ${productoARegalar.nombre}`,
          precio: totalExtrasCortesia,
          precioBaseCortesia: 0,
        });
      }
    }

    const promo2x1 = promocionesActivas.find(
      (p) => p.tipo === "2x1" && p.productoId === productoSeleccionado.id,
    );

    if (promo2x1) {
      nuevosItems.push({
        ...productoSeleccionado,
        cantidad: 1,
        idCarrito: `PROMO_2X1_${productoSeleccionado.id}_${timestamp}`,
        regaloDeIdCarrito: idCarritoPadre,
        promoId: promo2x1.id,
        extras: extrasCortesiaSeleccionados,
        comentario: comentarioCortesia.trim(),
        nombre: `[CORTESÍA] ${productoSeleccionado.nombre}`,
        precio: totalExtrasCortesia,
        precioBaseCortesia: 0,
      });
    }

    const carritoActualizado = [...carrito, ...nuevosItems];

    setCarrito(carritoActualizado);
    setMostrarModalProducto(false);
    setProductoSeleccionado(null);
    setOpcionesSeleccionadas({});
    setExtrasSeleccionados([]);
    setComentarioProducto("");
    setExtrasCortesiaSeleccionados([]);
    setComentarioCortesia("");
  };

  const totalCarrito = useMemo(() => {
    const total = carrito.reduce(
      (sum, item) => sum + (item.precio || 0) * (item.cantidad || 1),
      0,
    );

    return total > 0 ? total : 0;
  }, [carrito]);

  const productoCortesiaSeleccionado = useMemo(() => {
    if (!productoSeleccionado) return null;

    const promoRegalo = promocionesActivas.find(
      (p) => p.tipo === "regalo" && p.detonanteId === productoSeleccionado.id,
    );

    if (promoRegalo && promoRegalo.regaloId) {
      return (
        productos.find((p) => p.id === promoRegalo.regaloId) ||
        catalogoCompleto.find((p) => p.id === promoRegalo.regaloId) ||
        null
      );
    }

    const promo2x1 = promocionesActivas.find(
      (p) => p.tipo === "2x1" && p.productoId === productoSeleccionado.id,
    );

    if (promo2x1) {
      return productoSeleccionado;
    }

    return null;
  }, [productoSeleccionado, promocionesActivas, productos, catalogoCompleto]);

  const irAlCarrito = () => {
    navigate("/carrito", {
      state: {
        carrito,
        total: totalCarrito,
        promociones: promocionesActivas,
      },
    });
  };

  const handleInstalarApp = async () => {
    const yaEstaInstalada =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone;

    if (yaEstaInstalada) {
      setMensajeInstalacion("✅ La app ya está instalada en este dispositivo.");
      return;
    }

    if (installPromptEvent) {
      installPromptEvent.prompt();

      const resultado = await installPromptEvent.userChoice;

      if (resultado.outcome === "accepted") {
        setMensajeInstalacion("✅ Instalando app...");
      } else {
        setMensajeInstalacion("ℹ️ Instalación cancelada.");
      }

      setInstallPromptEvent(null);
      return;
    }

    setMensajeInstalacion(
      "📲 Para instalar: toca los 3 puntos de Chrome y elige “Instalar app” o “Agregar a pantalla principal”.",
    );
  };

  const handleCerrarSesion = async () => {
    try {
      await signOut(auth);
      navigate("/");
    } catch (err) {
      console.error("Error al salir:", err);
    }
  };

  if (cargandoSesion) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          backgroundColor: "#f4f4f6",
          fontFamily: "sans-serif",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <h2 style={{ fontWeight: "800", color: "#111" }}>MÍTICO AMORCITO</h2>
          <p style={{ color: "#666", fontSize: "14px" }}>
            Verificando credenciales seguras...
          </p>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        backgroundColor: "#f4f4f6",
        minHeight: "100vh",
        paddingBottom: "120px",
        fontFamily: "-apple-system, sans-serif",
        color: "#111",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <DecoracionesTienda />
      <BannerInstalarApp
        appInstalada={appInstalada}
        mensajeInstalacion={mensajeInstalacion}
        onInstalarApp={handleInstalarApp}
      />

      <AvisoTiendaCerrada estadoTienda={estadoTienda} />

      {modalInfoEspecial && (
        <div
          onClick={() => setModalInfoEspecial(null)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.65)",
            zIndex: 3000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "16px",
            boxSizing: "border-box",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: "#fff",
              borderRadius: "18px",
              width: "100%",
              maxWidth: "420px",
              maxHeight: "85vh",
              overflowY: "auto",
              boxShadow: "0 12px 30px rgba(0,0,0,0.25)",
              display: "flex",
              flexDirection: "column",
              position: "relative",
            }}
          >
            <button
              type="button"
              onClick={() => setModalInfoEspecial(null)}
              style={{
                position: "absolute",
                top: "12px",
                right: "12px",
                backgroundColor: "rgba(0,0,0,0.6)",
                color: "#fff",
                border: "none",
                borderRadius: "50%",
                width: "32px",
                height: "32px",
                cursor: "pointer",
                fontWeight: "900",
                zIndex: 10,
              }}
            >
              ✕
            </button>

            {modalInfoEspecial.url &&
              (modalInfoEspecial.tipo === "video" ? (
                <video
                  src={modalInfoEspecial.url}
                  controls
                  autoPlay
                  playsInline
                  style={{
                    width: "100%",
                    maxHeight: "240px",
                    objectFit: "cover",
                    borderTopLeftRadius: "18px",
                    borderTopRightRadius: "18px",
                    backgroundColor: "#000",
                  }}
                />
              ) : (
                <img
                  src={modalInfoEspecial.url}
                  alt={modalInfoEspecial.titulo}
                  style={{
                    width: "100%",
                    maxHeight: "240px",
                    objectFit: "cover",
                    borderTopLeftRadius: "18px",
                    borderTopRightRadius: "18px",
                  }}
                />
              ))}

            <div style={{ padding: "20px" }}>
              <h3
                style={{
                  margin: "0 0 8px 0",
                  fontSize: "18px",
                  fontWeight: "900",
                  color: "#111",
                }}
              >
                {modalInfoEspecial.titulo}
              </h3>

              <p
                style={{
                  margin: "0 0 14px 0",
                  fontSize: "13px",
                  color: "#555",
                  lineHeight: "1.5",
                  whiteSpace: "pre-line",
                }}
              >
                {modalInfoEspecial.descripcion}
              </p>

              {modalInfoEspecial.infoAdicional && (
                <div
                  style={{
                    backgroundColor: "#f9f9f9",
                    padding: "12px",
                    borderRadius: "10px",
                    fontSize: "13px",
                    color: "#333",
                    lineHeight: "1.5",
                    whiteSpace: "pre-line",
                    border: "1px solid #eee",
                    marginBottom: "16px",
                  }}
                >
                  {modalInfoEspecial.infoAdicional}
                </div>
              )}

              <button
                type="button"
                onClick={() => setModalInfoEspecial(null)}
                style={{
                  width: "100%",
                  backgroundColor: "#FF9900",
                  color: "#fff",
                  border: "none",
                  borderRadius: "10px",
                  padding: "12px",
                  fontWeight: "800",
                  fontSize: "14px",
                  cursor: "pointer",
                }}
              >
                Entendido
              </button>
            </div>
          </div>
        </div>
      )}

      <ModalProducto
        mostrar={mostrarModalProducto}
        producto={productoSeleccionado}
        cortesiaProducto={productoCortesiaSeleccionado}
        opcionesSeleccionadas={opcionesSeleccionadas}
        estadoTienda={estadoTienda}
        onCambiarOpcionSinCosto={handleCambiarOpcionSinCosto}
        extrasSeleccionados={extrasSeleccionados}
        comentarioProducto={comentarioProducto}
        extrasCortesiaSeleccionados={extrasCortesiaSeleccionados}
        comentarioCortesia={comentarioCortesia}
        onCambiarComentario={setComentarioProducto}
        onCambiarComentarioCortesia={setComentarioCortesia}
        onToggleExtra={handleToggleExtra}
        onToggleExtraCortesia={handleToggleExtraCortesia}
        onCerrar={() => setMostrarModalProducto(false)}
        onConfirmar={handleConfirmarAgregarAlCarrito}
      />

      <PopupEspecial
        mostrar={mostrarPopup}
        especial={especialActual}
        onCerrar={() => setMostrarPopup(false)}
        onClick={() => handleClickEspecial(especialActual)}
        onAnterior={handlePopupAnterior}
        onSiguiente={handlePopupSiguiente}
        cantidad={especiales.length}
        index={popupIndex}
      />

      {/* ENCABEZADO FIJO / STICKY: LOGO + BUSCADOR + TURNO */}
      <div
        style={{
          position: "sticky",
          top: 0,
          backgroundColor: "#ffffff",
          padding: "10px 16px 12px 16px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid #eaeaea",
          zIndex: 1000,
          boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
          boxSizing: "border-box",
          width: "100%",
        }}
      >
        <button
          onClick={() => setMenuAbierto(!menuAbierto)}
          style={{
            background: "none",
            border: "none",
            fontSize: "24px",
            cursor: "pointer",
            padding: 0,
            color: "#111",
            display: "flex",
            alignItems: "center",
          }}
        >
          ☰
        </button>

        <div style={{ flex: 1, padding: "0 12px", position: "relative" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "28px",
              marginBottom: "6px",
            }}
          >
            <button
              type="button"
              onMouseDown={iniciarPresionLogoAdmin}
              onMouseUp={cancelarPresionLogoAdmin}
              onMouseLeave={cancelarPresionLogoAdmin}
              onTouchStart={iniciarPresionLogoAdmin}
              onTouchEnd={cancelarPresionLogoAdmin}
              onTouchCancel={cancelarPresionLogoAdmin}
              onClick={handleClickLogoAdmin}
              style={{
                background: "none",
                border: "none",
                padding: 0,
                margin: 0,
                cursor: "default",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                userSelect: "none",
                WebkitUserSelect: "none",
              }}
            >
              <img
                src={logoNegocio}
                alt={`Logo ${nombreNegocio}`}
                loading="lazy"
                decoding="async"
                draggable="false"
                style={{
                  width: `${logoAnchoPx}px`,
                  maxHeight: `${logoAltoMaxPx}px`,
                  objectFit: "contain",
                  pointerEvents: "none",
                }}
                onError={(e) => {
                  e.target.style.display = "none";
                  const el = document.getElementById("texto-alternativo-logo");
                  if (el) el.style.display = "block";
                }}
              />
            </button>

            <h2
              id="texto-alternativo-logo"
              style={{
                margin: 0,
                fontSize: "16px",
                fontWeight: "800",
                display: "none",
              }}
            >
              {nombreNegocio.toUpperCase()}
            </h2>
          </div>

          <input
            value={busquedaTexto}
            autoComplete="off"
            onChange={(e) => {
              setBusquedaTexto(e.target.value);
              setMostrarResultadosBusqueda(true);
            }}
            onFocus={() => setMostrarResultadosBusqueda(true)}
            onBlur={() =>
              setTimeout(() => setMostrarResultadosBusqueda(false), 180)
            }
            placeholder="Buscar café, waffles, chilaquiles, jugos..."
            style={{
              width: "100%",
              height: "34px",
              borderRadius: "12px",
              border: "1px solid #eee",
              padding: "0 12px",
              fontSize: "13px",
              outline: "none",
              boxSizing: "border-box",
              backgroundColor: "#fafafa",
            }}
          />

          {mostrarResultadosBusqueda &&
            busquedaTexto.trim() !== "" &&
            (resultadosSecciones.length > 0 ||
              resultadosProductos.length > 0) && (
              <div
                style={{
                  position: "absolute",
                  left: "12px",
                  right: "12px",
                  top: "76px",
                  backgroundColor: "#fff",
                  border: "1px solid #eee",
                  borderRadius: "14px",
                  overflow: "hidden",
                  boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
                  zIndex: 2000,
                }}
              >
                {resultadosSecciones.length > 0 && (
                  <div
                    style={{
                      padding: "10px 12px",
                      borderBottom: "1px solid #f3f3f3",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "11px",
                        fontWeight: "900",
                        color: "#777",
                        marginBottom: "8px",
                      }}
                    >
                      SECCIONES
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "6px",
                      }}
                    >
                      {resultadosSecciones.map((sec) => (
                        <button
                          key={sec}
                          type="button"
                          onMouseDown={(e) => {
                            e.preventDefault();
                            setBusquedaTexto("");
                            setMostrarResultadosBusqueda(false);
                            irASeccion(sec);
                          }}
                          style={{
                            textAlign: "left",
                            background: "#fff",
                            border: "1px solid #f1f1f1",
                            padding: "10px 10px",
                            borderRadius: "12px",
                            cursor: "pointer",
                            fontSize: "13px",
                            fontWeight: "800",
                          }}
                        >
                          📁 {sec}
                        </button>
                      ))}
                    </div>
                  </div>
                )}

                {resultadosProductos.length > 0 && (
                  <div style={{ padding: "10px 12px" }}>
                    <div
                      style={{
                        fontSize: "11px",
                        fontWeight: "900",
                        color: "#777",
                        marginBottom: "8px",
                      }}
                    >
                      PRODUCTOS
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "6px",
                      }}
                    >
                      {resultadosProductos.map((p) => (
                        <button
                          key={p.id}
                          type="button"
                          onMouseDown={(e) => {
                            e.preventDefault();
                            setBusquedaTexto("");
                            setMostrarResultadosBusqueda(false);
                            handleAbrirConfiguracionProducto(p);
                          }}
                          style={{
                            textAlign: "left",
                            background: "#fff",
                            border: "1px solid #f1f1f1",
                            padding: "10px 10px",
                            borderRadius: "12px",
                            cursor: "pointer",
                            fontSize: "13px",
                            fontWeight: "800",
                            display: "flex",
                            justifyContent: "space-between",
                            gap: "10px",
                          }}
                        >
                          <span
                            style={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            🍔 {p.nombre}
                          </span>

                          <span style={{ fontWeight: "900", color: "#111" }}>
                            ${p.precio}
                          </span>
                        </button>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}
        </div>

        <span
          style={{
            fontSize: "10px",
            fontWeight: "800",
            backgroundColor: "#111",
            color: "#fff",
            padding: "5px 10px",
            borderRadius: "20px",
            textTransform: "uppercase",
            whiteSpace: "nowrap",
          }}
        >
          {turnoActual === "matutino" ? "🌅 MATUTINO" : "🌌 VESPERTINO"}
        </span>
      </div>

      {menuAbierto && (
        <>
          <div
            onClick={() => setMenuAbierto(false)}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0,0,0,0.5)",
              zIndex: 1099,
            }}
          />

          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "270px",
              bottom: 0,
              backgroundColor: "#fff",
              zIndex: 1100,
              padding: "25px 16px",
              boxSizing: "border-box",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "20px",
                }}
              >
                <h4
                  style={{
                    margin: 0,
                    fontSize: "13px",
                    fontWeight: "800",
                    color: "#777",
                    letterSpacing: "0.5px",
                  }}
                >
                  MI CUENTA MÍTICA
                </h4>

                <button
                  onClick={() => setMenuAbierto(false)}
                  style={{
                    background: "none",
                    border: "none",
                    fontSize: "16px",
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                >
                  ✕
                </button>
              </div>

              {usuario && (
                <div
                  style={{
                    backgroundColor: "#f4f4f6",
                    padding: "14px",
                    borderRadius: "12px",
                    marginBottom: "20px",
                    border: "1px solid #eee",
                  }}
                >
                  <span
                    style={{
                      fontSize: "13px",
                      fontWeight: "700",
                      display: "block",
                      color: "#111",
                      marginBottom: "2px",
                    }}
                  >
                    👤 {usuario.email}
                  </span>

                  <span
                    style={{
                      fontSize: "10px",
                      color: "#666",
                      fontFamily: "monospace",
                      display: "block",
                    }}
                  >
                    ID: {usuario.uid.slice(0, 12)}...
                  </span>
                </div>
              )}

              <h4
                style={{
                  margin: "15px 0 10px 0",
                  fontSize: "12px",
                  fontWeight: "800",
                  color: "#777",
                  letterSpacing: "0.5px",
                }}
              >
                CATEGORÍAS DE LA CARTA
              </h4>

              <div
                style={{ display: "flex", flexDirection: "column", gap: "4px" }}
              >
                {categoriasOrdenadas.map((sec, idx) => (
                  <button
                    key={idx}
                    onClick={() => irASeccion(sec)}
                    style={{
                      width: "100%",
                      textAlign: "left",
                      background: "none",
                      border: "none",
                      padding: "10px 5px",
                      fontSize: "14px",
                      fontWeight: "700",
                      cursor: "pointer",
                      borderBottom: "1px solid #f9f9f9",
                    }}
                  >
                    🍔 {sec}
                  </button>
                ))}
              </div>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                borderTop: "1px solid #eee",
                paddingTop: "15px",
              }}
            >
              <button
                type="button"
                onClick={handleInstalarApp}
                style={{
                  width: "100%",
                  backgroundColor: "#FF9900",
                  color: "#fff",
                  textAlign: "center",
                  padding: "12px 0",
                  borderRadius: "10px",
                  fontSize: "13px",
                  fontWeight: "700",
                  border: "none",
                  display: "block",
                  cursor: "pointer",
                }}
              >
                📲 Instalar App de Mítico
              </button>

              <button
                onClick={handleCerrarSesion}
                style={{
                  width: "100%",
                  backgroundColor: "#fff",
                  color: "#c5221f",
                  border: "1px solid #fce8e6",
                  padding: "10px 0",
                  borderRadius: "10px",
                  fontSize: "13px",
                  fontWeight: "700",
                  cursor: "pointer",
                }}
              >
                Cerrar Sesión
              </button>
            </div>
          </div>
        </>
      )}

      <div
        style={{
          position: "relative",
          width: "100%",
          height: "170px",
          overflow: "hidden",
          backgroundColor: "#000",
        }}
      >
        {bannersVisibles.map((banner, index) => (
          <div
            key={banner.id}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              opacity: bannerActivo === index ? 1 : 0,
              transition: "opacity 0.6s ease-in-out",
              display: "flex",
              alignItems: "center",
            }}
          >
            <img
              src={banner.url}
              alt=""
              loading="lazy"
              decoding="async"
              style={{
                position: "absolute",
                right: 0,
                width: "55%",
                height: "100%",
                objectFit: "cover",
                zIndex: 1,
              }}
            />

            <div
              style={{
                position: "absolute",
                left: 0,
                top: 0,
                bottom: 0,
                width: "65%",
                background: "linear-gradient(to right, #000 75%, transparent)",
                zIndex: 2,
                padding: "20px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                color: "#fff",
                boxSizing: "border-box",
              }}
            >
              {banner.titulo && (
                <>
                  <span
                    style={{
                      fontSize: "9px",
                      fontWeight: "800",
                      backgroundColor: "#FF9900",
                      padding: "3px 6px",
                      borderRadius: "4px",
                      display: "inline-block",
                      marginBottom: "6px",
                      width: "fit-content",
                    }}
                  >
                    MÍTICO AMORCITO
                  </span>

                  <h3
                    style={{
                      margin: "0 0 4px 0",
                      fontSize: "19px",
                      fontWeight: "900",
                      lineHeight: "1.1",
                      letterSpacing: "-0.5px",
                    }}
                  >
                    {banner.titulo}
                  </h3>
                </>
              )}

              {banner.subtitulo && (
                <p
                  style={{
                    margin: 0,
                    fontSize: "12px",
                    color: "#ccc",
                    lineHeight: "1.3",
                    fontWeight: "400",
                  }}
                >
                  {banner.subtitulo}
                </p>
              )}
            </div>
          </div>
        ))}

        {bannersVisibles.length > 1 && (
          <div
            style={{
              position: "absolute",
              bottom: "12px",
              left: "20px",
              display: "flex",
              gap: "6px",
              zIndex: 3,
            }}
          >
            {bannersVisibles.map((_, i) => (
              <div
                key={i}
                style={{
                  width: "6px",
                  height: "6px",
                  borderRadius: "50%",
                  backgroundColor:
                    bannerActivo === i ? "#fff" : "rgba(255,255,255,0.4)",
                  transition: "0.3s",
                }}
              />
            ))}
          </div>
        )}
      </div>

      <CategoriasTienda
        listaDeSecciones={categoriasOrdenadas}
        menuAgrupadoPorSeccion={menuAgrupadoPorSeccion}
        categoriaAnimadaIndex={categoriaAnimadaIndex}
        onIrASeccion={irASeccion}
      />

      <div id="mis-favoritos">
        <SeccionProductosHorizontal
          titulo="❤️ Mis favoritos"
          subtitulo="Tus productos guardados para pedir más rápido."
          productos={productosFavoritos}
          logoNegocio={logoNegocio}
          onAbrirProducto={handleAbrirConfiguracionProducto}
          mostrarBotonFavorito={true}
          favoritosIds={favoritosIds}
          onToggleFavorito={toggleFavorito}
        />
      </div>
      <SeccionProductosHorizontal
        titulo="🧾 Mi último pedido"
        subtitulo="Los productos de tu compra más reciente."
        productos={productosUltimoPedido}
        logoNegocio={logoNegocio}
        onAbrirProducto={handleAbrirConfiguracionProducto}
        mostrarBotonFavorito={true}
        favoritosIds={favoritosIds}
        onToggleFavorito={toggleFavorito}
      />

      {especialesVisibles.length > 0 && (
        <div style={{ padding: "20px 0 10px 16px" }}>
          <h3
            style={{
              margin: "0 0 2px 0",
              fontSize: "17px",
              fontWeight: "900",
              letterSpacing: "-0.5px",
            }}
          >
            🌟 Especiales del Mes
          </h3>

          <p style={{ margin: "0 0 12px 0", fontSize: "12px", color: "#666" }}>
            Consulta nuestros imperdibles y promociones vigentes.
          </p>

          <div
            ref={especialesScrollRef}
            style={{
              display: "flex",
              gap: "14px",
              overflowX: "auto",
              paddingRight: "16px",
              scrollbarWidth: "none",
              scrollBehavior: "smooth",
            }}
          >
            {especialesVisibles.map((esp) => (
              <EspecialCard
                key={esp.id}
                esp={esp}
                onClick={() => handleClickEspecial(esp)}
              />
            ))}
          </div>
        </div>
      )}

      <SeccionProductosHorizontal
        titulo="🔥 Los Favoritos del Turno"
        subtitulo="Lo que más se está pidiendo a esta hora en la cocina."
        productos={masVendidosRelleno}
        logoNegocio={logoNegocio}
        onAbrirProducto={handleAbrirConfiguracionProducto}
        mostrarBotonFavorito={true}
        favoritosIds={favoritosIds}
        onToggleFavorito={toggleFavorito}
      />

      <div style={{ padding: "8px 16px 0 16px" }}>
        {[
          {
            titulo: "🍳 ALIMENTOS",
            categorias: categoriasPorGrupo.alimentos,
          },
          {
            titulo: "🥤 BEBIDAS",
            categorias: categoriasPorGrupo.bebidas,
          },
        ].map((grupo) =>
          grupo.categorias.length > 0 ? (
            <div key={grupo.titulo} style={{ marginBottom: "28px" }}>
              <button
                type="button"
                onClick={() =>
                  setGruposAbiertos((prev) => ({
                    ...prev,
                    [grupo.titulo.includes("ALIMENTOS")
                      ? "ALIMENTOS"
                      : "BEBIDAS"]:
                      !prev[
                        grupo.titulo.includes("ALIMENTOS")
                          ? "ALIMENTOS"
                          : "BEBIDAS"
                      ],
                  }))
                }
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "14px",
                  padding: "12px 14px",
                  background: "#fff",
                  border: "1px solid #ececec",
                  borderRadius: "14px",
                  cursor: "pointer",
                }}
              >
                <h2
                  style={{
                    margin: 0,
                    fontSize: "22px",
                    fontWeight: "900",
                    color: "#111",
                    letterSpacing: "-0.5px",
                  }}
                >
                  {grupo.titulo}
                </h2>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <span
                    style={{
                      fontSize: "12px",
                      fontWeight: "800",
                      color: "#777",
                      background: "#f7f7f7",
                      border: "1px solid #ececec",
                      padding: "4px 10px",
                      borderRadius: "999px",
                    }}
                  >
                    {grupo.categorias.length} categorías
                  </span>

                  <span
                    style={{
                      fontSize: "18px",
                      fontWeight: "900",
                      color: "#666",
                      transform: gruposAbiertos[
                        grupo.titulo.includes("ALIMENTOS")
                          ? "ALIMENTOS"
                          : "BEBIDAS"
                      ]
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                      transition: "transform .25s ease",
                    }}
                  >
                    ⌄
                  </span>
                </div>
              </button>

              <div
                style={{
                  display: "grid",
                  gridTemplateRows: gruposAbiertos[
                    grupo.titulo.includes("ALIMENTOS") ? "ALIMENTOS" : "BEBIDAS"
                  ]
                    ? "1fr"
                    : "0fr",
                  transition: "grid-template-rows .35s ease",
                }}
              >
                <div
                  style={{
                    overflow: "hidden",
                  }}
                >
                  {grupo.categorias.map((seccionNombre) => (
                    <AcordeonCategoria
                      key={seccionNombre}
                      categoriaRef={(el) =>
                        (seccionesRef.current[seccionNombre] = el)
                      }
                      seccionNombre={seccionNombre}
                      productosSeccion={
                        menuAgrupadoPorSeccion[seccionNombre] || []
                      }
                      abierta={Boolean(categoriasAbiertas[seccionNombre])}
                      onToggle={() => toggleCategoria(seccionNombre)}
                      logoNegocio={logoNegocio}
                      onAbrirProducto={handleAbrirConfiguracionProducto}
                      favoritosIds={favoritosIds}
                      onToggleFavorito={toggleFavorito}
                    />
                  ))}
                </div>
              </div>
            </div>
          ) : null,
        )}
      </div>

      <BarraNavegacionInferior
        favoritos={productosFavoritos.length}
        carrito={carrito.reduce((suma, item) => suma + (item.cantidad || 1), 0)}
        onInicio={() =>
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          })
        }
        onFavoritos={() => {
          const elemento = document.getElementById("mis-favoritos");

          if (elemento) {
            elemento.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }
        }}
        onCarrito={irAlCarrito}
        onCuenta={() => setMenuAbierto(true)}
      />

      <div style={{ marginBottom: "76px" }}>
        <FloatingCart
          carrito={carrito}
          total={totalCarrito}
          onClick={irAlCarrito}
        />
      </div>
    </div>
  );
}

export default Tienda;
